export const impresionData = [{
    "_id": {
        "$oid": "67ab89dc06ba75fda06a72e0"
    },
    "nombre": "Bandeja de impresora Advanced ",
    "descripcion": "Bandeja de impresora compatible con ECG Advanced 12C.",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1739309293820-BandejaAdvanced.jpeg",
    "date": {
        "$date": "2025-02-11T17:33:16.767Z"
    }
},
{
    "_id": {
        "$oid": "671fbeb0c23df6e7b81ff560"
    },
    "nombre": "Grommet para incubadora",
    "descripcion": "Grommet para incubadora. Material: TPU",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1738348695743-Goma_cuna.jpg",
    "date": {
        "$date": "2024-10-28T16:41:20.247Z"
    }
},
{
    "_id": {
        "$oid": "671fbbc1c23df6e7b81ff545"
    },
    "nombre": "Soporte para lampara",
    "descripcion": "Pieza plástica para soporte de lampara ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1731020469348-Soporte lampara.jpeg",
    "date": {
        "$date": "2024-10-28T16:28:49.836Z"
    }
},
{
    "_id": {
        "$oid": "671fb8b7c23df6e7b81ff4e8"
    },
    "nombre": "Abrazadera / Alineador de colchón Hill-Rom",
    "descripcion": "Alineador de colchón compatible con cama hospitalaria Hill Rom",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1730132135084-AlineadorColchon.png",
    "date": {
        "$date": "2024-10-28T16:15:51.194Z"
    }
},
{
    "_id": {
        "$oid": "670d917bc23df6e7b81fd4cf"
    },
    "nombre": "Pieza exterior de maneral para lampara ",
    "descripcion": "Parte exterior de plástico para maneral/antorcha compatible con lampara quirúrgica Mindray Hyled 600",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1728935525385-maneral-exterior.png",
    "date": {
        "$date": "2024-10-14T21:47:39.415Z"
    }
},
{
    "_id": {
        "$oid": "670d71b9c23df6e7b81fd440"
    },
    "nombre": "Pieza interior de maneral para lámpara",
    "descripcion": "Parte interior de plástico para maneral/antorcha compatible con lampara quirúrgica Mindray Hyled 600",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1728935534192-maneral-interior.png",
    "date": {
        "$date": "2024-10-14T19:32:09.327Z"
    }
},
{
    "_id": {
        "$oid": "6705a6f5c23df6e7b81fc9cc"
    },
    "nombre": "Porta electrodo Nihon Kohden",
    "descripcion": "Porta electrodo de plástico compatible con desfibrilador Nihon Kohden",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1728423338437-Portaelectrodo.png",
    "date": {
        "$date": "2024-10-08T21:41:09.919Z"
    }
},
{
    "_id": {
        "$oid": "670564f0c23df6e7b81fc769"
    },
    "nombre": "Bandeja Burdick EK10",
    "descripcion": "Bandeja plástica con rodillo compatible con impresora de electrocardiógrafo Burdick EK10",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1728406580591-BandejaBurdickRodillo.png",
    "date": {
        "$date": "2024-10-08T16:59:28.500Z"
    }
},
{
    "_id": {
        "$oid": "67056010c23df6e7b81fc71f"
    },
    "nombre": "Cuerpo para válvula espiratoria",
    "descripcion": "Cuerpo plástico para válvula espiratoria compatible con ventilador Siare ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1730131994013-CuerpoValvula.png",
    "date": {
        "$date": "2024-10-08T16:38:40.406Z"
    }
},
{
    "_id": {
        "$oid": "66f6def8c23df6e7b81fa959"
    },
    "nombre": "Abrazadera rayos X ",
    "descripcion": "Abrazadera fabricada en filamento blanco ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1727455138985-Abrazadera.png",
    "date": {
        "$date": "2024-09-27T16:36:08.934Z"
    }
},
{
    "_id": {
        "$oid": "66f17bc648a7ebcfe937b9af"
    },
    "nombre": "Conector de aire Medela",
    "descripcion": "Conector de aire compatible con aspirador Medela Basic",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1727466921884-cople_medela_basic.jpeg",
    "date": {
        "$date": "2024-09-23T14:31:34.043Z"
    }
},
{
    "_id": {
        "$oid": "66a271216c29941ad1ffdcc7"
    },
    "nombre": "Carcasa control Sismatec",
    "descripcion": "Carcasa compatible con control de mano Sismatec Mastertec. ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721921638722-ControlSismatec.png",
    "date": {
        "$date": "2024-07-25T15:37:05.525Z"
    }
},
{
    "_id": {
        "$oid": "669eb328b889fce0e715b43a"
    },
    "nombre": "Batería ECG Trim",
    "descripcion": "Batería compatible con electrocardiógrafo philips pagewriter trim I, II, III",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721676425432-BateriaTrim.png",
    "date": {
        "$date": "2024-07-22T19:29:44.230Z"
    }
},
{
    "_id": {
        "$oid": "669e7d61b889fce0e715b18c"
    },
    "nombre": "Tapa Cardiocap S/5",
    "descripcion": "Tapa compatible con monitor Cardiocap S/5 con etiqueta de poliéster",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721662747697-Tapacardiocap S5M2.png",
    "date": {
        "$date": "2024-07-22T15:40:17.576Z"
    }
},
{
    "_id": {
        "$oid": "669e7ce3b889fce0e715b169"
    },
    "nombre": "Tapa Cardiocap S/5",
    "descripcion": "Tapa compatible con monitor Cardiocap S/5 con etiqueta de poliéster",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721662662884-Tapacardiocap S5M1.png",
    "date": {
        "$date": "2024-07-22T15:38:11.505Z"
    }
},
{
    "_id": {
        "$oid": "6696a1a8b889fce0e715a9be"
    },
    "nombre": "Esquineros para cuna térmica ",
    "descripcion": "Juego de esquineros para cuna térmica ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1729527816638-Esquineros.jpeg",
    "date": {
        "$date": "2024-07-16T16:36:56.060Z"
    }
},
{
    "_id": {
        "$oid": "6696929cb889fce0e715a908"
    },
    "nombre": "Tapa impresora Edan",
    "descripcion": "Tapa plástica de impresora compatible con ECG Edan SE 1200",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721143570833-EdanSE1200.png",
    "date": {
        "$date": "2024-07-16T15:32:44.341Z"
    }
},
{
    "_id": {
        "$oid": "66959b67b889fce0e715a8a9"
    },
    "nombre": "Soporte rueda",
    "descripcion": "Soporte para vástago de rueda ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721083222196-soporte vastago.png",
    "date": {
        "$date": "2024-07-15T21:57:59.512Z"
    }
},
{
    "_id": {
        "$oid": "66955c27b0a2b1bfa7889163"
    },
    "nombre": "Cople Scope Buddy ",
    "descripcion": "Coples de plástico compatibles con equipo Scope Buddy. ",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1721064440645-CoplesScopeBuddy.png",
    "date": {
        "$date": "2024-07-15T17:28:07.780Z"
    }
},
{
    "_id": {
        "$oid": "66900de1b0a2b1bfa7888b20"
    },
    "nombre": "Juego de perillas Zoll",
    "descripcion": "Juego de perillas para desfibrilador Zoll M Series, incluye una perilla de on/off y dos perillas chicas de selección. Material: PetG",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1720716157448-Juegoperillas.jpeg",
    "date": {
        "$date": "2024-07-11T16:52:49.007Z"
    }
},
{
    "_id": {
        "$oid": "667d87238e6dbe95e82a66fb"
    },
    "nombre": "Tuerca de Elevación Hill Rom",
    "descripcion": "Tuerca de elevación compatible con cama hospitalaria Hill Rom",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1719502460751-WhatsApp Image 2024-06-26 at 1.07.29 PM.jpeg",
    "date": {
        "$date": "2024-06-27T15:37:07.187Z"
    }
},
{
    "_id": {
        "$oid": "667c5f518e6dbe95e82a6551"
    },
    "nombre": "Encoder deslizante Hill Rom",
    "descripcion": "Encoder deslizante para tuerca de elevación Hill Rom",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1718045995579-WhatsApp Image 2024-06-10 at 12.56.33 PM.jpeg",
    "date": {
        "$date": "2024-06-26T18:34:57.746Z"
    }
},
{
    "_id": {
        "$oid": "6674b20c8e6dbe95e82a58a9"
    },
    "nombre": "Carcasa superior Zoll con asa de transporte",
    "descripcion": "Carcasa superior Zoll con asa de transporte, compatible con el modelo M Series.",
    "categoria": "Impresion 3D",
    "imagen": "https://sistema.juvalfri.com/1718915144289-DZ.jfif",
    "date": {
        "$date": "2024-06-20T22:49:48.870Z"
    }
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd6"
    },
    "descripcion": "Carcasa plástica para realizar el inserto de la batería del electrocardiógrafo Philips Trim I, II, III. * No incluye batería ni placa electrónica",
    "nombre": "Carcasa Batería Trim",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:47:32.764Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707778058923-IMG_032.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd5"
    },
    "descripcion": "Tapa compatible con impresora de desfibrilador Philips HeartStart XL. Incluye etiqueta, bujes, engrane y rodillo.",
    "nombre": "Tapa Heartstart XL",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:47:20.725Z"
    },
    "imagen": "https://sistema.juvalfri.com/1742316034341-heartstart_completo.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd4"
    },
    "descripcion": "Tapa compatible con impresora de desfibrilador Philips HeartStart XL. Incluye etiqueta.",
    "nombre": "Tapa Heartstart con etiquetas",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:46:54.437Z"
    },
    "imagen": "https://sistema.juvalfri.com/1720191687088-tapaHeartStart.jpeg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd3"
    },
    "descripcion": "Carcasa superior compatible con aspirador de ultrasonido Sonopet",
    "nombre": "Carcasa Sonopet",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:46:25.867Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777990772-IMG_029.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd2"
    },
    "descripcion": "Tapa compatible con el compartimento de batería del monitor Mindray PM 9000",
    "nombre": "Tapa PM 9000",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:46:09.984Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777964460-IMG_028.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd1"
    },
    "descripcion": "Tapa compatible con el compartimento de batería de la báscula Seca 354",
    "nombre": "Tapa Seca 354",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:45:29.580Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777935331-IMG_027.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd0"
    },
    "descripcion": "Tapa compatible con el compartimento de batería de la báscula Seca 813",
    "nombre": "Tapa Seca 813",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:45:20.675Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777916097-IMG_026.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dcf"
    },
    "descripcion": "Base para palas compatible con desfibrilador Cardio Aid",
    "nombre": "Base para palas Cardio Aid",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:44:43.414Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777891456-IMG_025.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dce"
    },
    "descripcion": "Pala plástica de repuesto compatible con desfibrilador Cardio Aid",
    "nombre": "Pala Cardio Aid",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:44:06.977Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777867890-IMG_024_2.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dcd"
    },
    "descripcion": "Pieza de plástico de repuesto diseñada para la fijación segura de los electrodos del desfibrilador Cardio Aid",
    "nombre": "Base para electrodo Cardio Aid",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:43:52.917Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777827686-IMG_023.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dcc"
    },
    "descripcion": "Asa de transporte compatible con desfibrilador Zoll",
    "nombre": "Asa para Carcasa Zoll",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:42:39.496Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777770076-IMG_022.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dcb"
    },
    "descripcion": "Carcasa superior compatible con desfibrilador Zoll M Series",
    "nombre": "Carcasa superior Zoll",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:42:17.573Z"
    },
    "imagen": "https://sistema.juvalfri.com/1720712130862-DZoll.jpeg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dca"
    },
    "descripcion": "Soporte para cabezal de impresión de desfibrilador Zoll",
    "nombre": "Sujetador Bandeja Zoll",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:42:02.646Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777716945-IMG_020.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc9"
    },
    "descripcion": "Tapa para compartimento de batería de monitor doppler Sonomedic",
    "nombre": "Tapa Sonomedic",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:41:41.500Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777696046-IMG_019.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc8"
    },
    "descripcion": "Tapa para aspirador compatible con Medela Basic 300",
    "nombre": "Tapa para Aspirador",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:41:19.282Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777672760-IMG_018_1.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc7"
    },
    "descripcion": "Bandeja para impresora de desfibrilador Zoll, incluye etiquetas, bujes, engrane y rodillo.",
    "nombre": "Bandeja Zoll",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:40:57.095Z"
    },
    "imagen": "https://sistema.juvalfri.com/1719504929658-BzollRodillo.png"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc6"
    },
    "descripcion": "Bandeja para impresora de desfibrilador Zoll, incluye etiquetas.",
    "nombre": "Bandeja Zoll con etiquetas",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:40:33.192Z"
    },
    "imagen": "https://sistema.juvalfri.com/1718059396561-BZoll.png"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc5"
    },
    "descripcion": "Carcasa plástica del control de mano compatible con mesa quirúrgica Trumpf",
    "nombre": "Control Trumpf",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:40:23.635Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777617627-IMG_015.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc4"
    },
    "descripcion": "Camisa para tubos de ensayo de 13mm",
    "nombre": "Camisa para Centrifuga",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:39:55.033Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777599674-IMG_014.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc3"
    },
    "descripcion": "Bisagra para display compatible con monitor fetal Avalon FM20, FM30",
    "nombre": "Bisagra Avalon",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:39:34.478Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777580318-IMG_013.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc2"
    },
    "descripcion": "Perilla de selección compatible con electrocardiógrafo Trim",
    "nombre": "Perilla Trim",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:39:08.274Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777560470-IMG_012.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc1"
    },
    "descripcion": "Perilla de selección compatible con monitor de signos vitales Drager",
    "nombre": "Perilla Drager",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:38:33.383Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777535594-IMG_011.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc0"
    },
    "descripcion": "Soporte para display compatible con monitor fetal Avalon FM20, FM30",
    "nombre": "Soporte Display",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:38:19.184Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777492877-IMG_010.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dbf"
    },
    "descripcion": "Pieza para remplazo de gomas de pedal para cama Hill Rom",
    "nombre": "Pedal para Cama",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:37:51.584Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777465697-IMG_009.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dbe"
    },
    "descripcion": "Marcador de eventos genérico compatible con monitores fetales con entrada jack 3.5 mm",
    "nombre": "Marcador de Eventos",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:37:30.384Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777442921-IMG_008.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dbd"
    },
    "descripcion": "Tapa para impresora compatible con esterilizador Tuttnauer.",
    "nombre": "Tapa Tuttnauer",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:36:53.857Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777399747-IMG_007.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dbc"
    },
    "descripcion": "Buje con rosca externa M12 X2.000 de 38 mm longitud con tuerca ideal para la protección de cables eléctricos",
    "nombre": "Prensa Cables",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:36:21.760Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777373372-IMG_006.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dbb"
    },
    "descripcion": "Base para enconder compatible con centrifugadora Beckman TJ-6",
    "nombre": "Base para Encoder",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:35:56.623Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777352340-IMG_005.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dba"
    },
    "descripcion": "Tapa compatible con amalgamadora Millenium 2000",
    "nombre": "Tapa para Amalgamadora",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:35:37.885Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777330053-IMG_004.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db9"
    },
    "descripcion": "Grapa para sujeción de cables compatible con brazo para carrito de transporte de electrocardiógrafo Trim",
    "nombre": "Grapas Sujeción Trim",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:35:15.246Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777307133-IMG_003.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db8"
    },
    "descripcion": "Tapa para compartimento de batería de electrocardiógrafo Trim I,II,III",
    "nombre": "Tapa batería ECG Trim",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:34:53.198Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777284912-IMG_002.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db7"
    },
    "descripcion": "Soporte para barandal de cama hospitalaria fabricado en resina resistente al impacto",
    "nombre": "Soporte para Barandal",
    "categoria": "Impresion 3D",
    "date": {
        "$date": "2024-02-12T22:34:12.572Z"
    },
    "imagen": "https://sistema.juvalfri.com/1707777240129-IMG_001.jpg"
}];

export const tecladosData = [{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d86"
    },
    "descripcion": "Teclado de membrana compatible con monitor de signos vitales Drager Infinity Delta",
    "nombre": "Teclado Drager Infinity Delta",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707837345808-TM001.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d87"
    },
    "descripcion": "Teclado de membrana compatible con electrocauterio Valleylab Force FX",
    "nombre": "Teclado Valleylab Force FX",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707837763162-TM002.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d88"
    },
    "descripcion": "Teclado de membrana compatible con unidad dental Rojas Dent",
    "nombre": "Teclado Rojas Dent",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707838222768-TM003.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d89"
    },
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Trumpf Saturn Select",
    "nombre": "Teclado Trumpf Saturn Select",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707838353828-TM004.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8a"
    },
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Trumpf Saturn",
    "nombre": "Teclado Trumpf Saturn",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707840334966-TM005.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8b"
    },
    "descripcion": "Teclado de membrana compatible con el control de mano para mesa de cirugía Trumpf Saturn",
    "nombre": "Teclado Control Trumpf Saturn",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707840860178-TM006.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8c"
    },
    "descripcion": "Teclado de membrana compatible con el control de mano para mesa de cirugía Steris ASC 2000",
    "nombre": "Teclado Control Steris ASC 2000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707841333251-TM007.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8d"
    },
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Medifa 6000 Series",
    "nombre": "Teclado Medifa 6000 Series",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707841530171-TM008.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8e"
    },
    "descripcion": "Teclado de membrana compatible con electrocauterio Valleylab Force 2 (12 btn)",
    "nombre": "Teclado Valleylab Force 2 (12 btn)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707841731203-TM009.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d8f"
    },
    "descripcion": "Teclado de membrana compatible con electrocauterio Valleylab Force 2 (2 btn)",
    "nombre": "Teclado Valleylab Force 2 (2 btn)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707846238311-TM010.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d90"
    },
    "descripcion": "Teclado de membrana compatible con monitor de signos vitales Drager Infinity Vista XL",
    "nombre": "Teclado Drager Infinity Vista XL",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707841846845-TM011.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d91"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Hill Rom AvantGuard 1600 (18 btn)",
    "nombre": "Teclado Hill Rom AvantGuard 1600 (18 btn)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842010371-TM012.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d92"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Hill Rom AvantGuard 1600 (6 btn)",
    "nombre": "Teclado Hill Rom AvantGuard 1600 (6 btn)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842033114-TM013.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d93"
    },
    "descripcion": "Teclado de membrana compatible con esterilizador Tuttnauer Cat 2007",
    "nombre": "Teclado Tuttnauer Cat 2007",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842111025-TM014.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d94"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Linet",
    "nombre": "Teclado Linet",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842217829-TM015.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d95"
    },
    "descripcion": "Teclado de membrana compatible con desfibrilador Zoll M Series",
    "nombre": "Teclado Zoll M Series",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842298518-TM016.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d96"
    },
    "descripcion": "Teclado de membrana compatible con unidad dental Omega",
    "nombre": "Teclado Omega",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842374617-TM017.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d97"
    },
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Schmitz RC-30",
    "nombre": "Teclado Schmitz RC-30",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842494141-TM018.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d98"
    },
    "descripcion": "Teclado de membrana compatible con bomba de jeringa DRE SP 1500 Plus",
    "nombre": "Teclado DRE SP 1500 Plus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842574840-TM019.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d99"
    },
    "descripcion": "Teclado de membrana compatible con rayos X mobil Philips Practix Convenio",
    "nombre": "Teclado Philips Practix Convenio",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707842973152-TM020.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9a"
    },
    "descripcion": "Teclado de membrana compatible con rayos X mobil Siemens Polymobil Plus",
    "nombre": "Teclado Siemens Polymobil Plus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843069557-TM021.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9b"
    },
    "descripcion": "Teclado de membrana compatible con rayos X mobil Siemens Polymobil III",
    "nombre": "Teclado Siemens Polymobil III",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843145269-TM022.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9c"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Linet Stryker Go Bed FL17E",
    "nombre": "Teclado Stryker Go Bed FL17E",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843233088-TM023.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9d"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Linet Stryker Go Bed FL23E",
    "nombre": "Teclado Stryker Go Bed FL23E",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843305151-TM024.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9e"
    },
    "descripcion": "Teclado de membrana compatible con lampara quirúrgica Brandon Medical Galaxy Ultra 30",
    "nombre": "Teclado Brandon Medical GU30LC",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843370884-TM025.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d9f"
    },
    "descripcion": "Teclado de membrana compatible con bomba de infusión Daiwa DI-4000",
    "nombre": "Teclado Daiwa DI-4000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843438187-TM026.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da0"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker Muka HC 1100 (lado izquierdo)",
    "nombre": "Teclado Stryker Muka HC 1100 (izquierda)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843534726-TM027.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da1"
    },
    "descripcion": "Teclado de membrana compatible con centrifuga IKA Mini G",
    "nombre": "Teclado IKA Mini G",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843592184-TM028.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da2"
    },
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Medifa MOT 6000",
    "nombre": "Teclado Medifa MOT 6000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843653338-TM029.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da3"
    },
    "descripcion": "Teclado de membrana compatible con incubadora de transporte Medix TR-200",
    "nombre": "Teclado Medix TR-200",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843724819-TM030.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da4"
    },
    "descripcion": "Teclado de membrana compatible con lampara quirúrgica Cobramex",
    "nombre": "Teclado Cobramex",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843837075-TM031.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da5"
    },
    "descripcion": "Teclado de membrana compatible con lampara quirúrgica Mediland",
    "nombre": "Teclado Mediland",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843905398-TM032.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da6"
    },
    "descripcion": "Teclado de membrana compatible con autoclave Midmark M9/M11",
    "nombre": "Teclado Midmark M9/M11",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707843967717-TM033.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da7"
    },
    "descripcion": "Teclado de membrana compatible con láser infrarrojo Mettler Electronics Sys Stim 540",
    "nombre": "Teclado Mettler Electronics Sys Stim 540",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707844079306-TM034.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da8"
    },
    "descripcion": "Teclado de membrana compatible con centrifuga de baja velocidad VE-4000 Plus",
    "nombre": "Teclado Velab 4000 Plus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1707844153224-TM035.jpg"
},
{
    "_id": {
        "$oid": "66969492b889fce0e715a93f"
    },
    "nombre": "Teclado GE MAC 2000",
    "descripcion": "Teclado de membrana compatible con ECG GE Healtcare Mac 2000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1721143554667-GEMac2000.png"
},
{
    "_id": {
        "$oid": "669eaa83b889fce0e715b3c3"
    },
    "nombre": "Teclado Atmoscare Exspecta",
    "descripcion": "Teclado de membrana compatible con cuna de calor radiante Atmoscare Exspecta",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1721322881233-cunatermica.png"
},
{
    "_id": {
        "$oid": "669eabbeb889fce0e715b3fb"
    },
    "nombre": "Teclado Advanced",
    "descripcion": "Teclado de membrana compatible con lampara de cirugía Advanced",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1721674638352-Advanced.png"
},
{
    "_id": {
        "$oid": "66b62df0bdfd1d6056aa8d09"
    },
    "nombre": "Teclado Gaggia",
    "descripcion": "Teclado de membrana compatible con equipo Gaggia",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1723215257686-Gaggia.png"
},
{
    "_id": {
        "$oid": "66b62e81bdfd1d6056aa8d1d"
    },
    "nombre": "Teclado Saeco",
    "descripcion": "Teclado de membrana compatible con equipo Saeco",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1723215266497-Saeco.png"
},
{
    "_id": {
        "$oid": "66e99d3648a7ebcfe937a5c4"
    },
    "nombre": "Teclado Stryker Muka HC 1100 (derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker Muka HC 1100 (lado derecho)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726586111615-muka_derecha.png"
},
{
    "_id": {
        "$oid": "66e99f0948a7ebcfe937a5f4"
    },
    "nombre": "Teclado Carefusion Vela",
    "descripcion": "Teclado de Membrana compatible con ventilador mecánico Carefusion Vela",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726586592796-vela.png"
},
{
    "_id": {
        "$oid": "66e9a3e448a7ebcfe937a620"
    },
    "nombre": "Teclado Philips Respironics V200",
    "descripcion": "Teclado de membrana compatible con ventilador Philips Respironics V200",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726586837536-V200.png"
},
{
    "_id": {
        "$oid": "66e9aaa848a7ebcfe937a6c5"
    },
    "nombre": "Teclado Datex Ohmeda Aisys Carestation",
    "descripcion": "Teclado de membrana compatible con maquina de anestesia Datex Ohmeda Aisys Carestation",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726589235868-datexOhmedaAisysCarestation.png"
},
{
    "_id": {
        "$oid": "66e9ab4148a7ebcfe937a6e8"
    },
    "nombre": "Teclado Datex Ohmeda Engstrom Carestation",
    "descripcion": "Teclado de membrana compatible con ventilador mecánico pulmonar Datex-Ohmeda Engstrom Carestation",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726589242933-datexOhmedaEngstromCarestation.png"
},
{
    "_id": {
        "$oid": "66e9b1cc48a7ebcfe937a76b"
    },
    "nombre": "Teclado Drager Infinity Vista",
    "descripcion": "Teclado de membrana compatible con monitor de signos vitales Drager Infinity Vista",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726591077068-Drager_infinity_vista.png"
},
{
    "_id": {
        "$oid": "66e9b4a548a7ebcfe937a78a"
    },
    "nombre": "Teclado Schaerer Arcus",
    "descripcion": "Teclado de membrana compatible con mesa quirúrgica Schaerer Arcus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726591091705-mesaQuirurgica_schaerer.png"
},
{
    "_id": {
        "$oid": "66e9f1ca48a7ebcfe937a926"
    },
    "nombre": "Teclado LipoMax RF",
    "descripcion": "Teclado de membrana compatible con equipo de medicina estética LipoMax RF",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726593942765-lipoMaxRf.png"
},
{
    "_id": {
        "$oid": "66e9f2fb48a7ebcfe937a94b"
    },
    "nombre": "Teclado Thermo Scientific Super Nuova",
    "descripcion": "Teclado de membrana compatible con agitador magnético Thermo Scientific Super Nuova",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726597106758-ThermoScientific.png"
},
{
    "_id": {
        "$oid": "66feb9fcc23df6e7b81fb8d5"
    },
    "nombre": "Teclado Hill Rom Care Assist (derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Hill Rom Care Assist (lado derecho)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1724258102861-Hillroom_AsistCare_derecha.png"
},
{
    "_id": {
        "$oid": "66feba98c23df6e7b81fb8f4"
    },
    "nombre": "Teclado Hill Rom Care Assist (izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Hill Rom Care Assist (lado izquierdo)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1724258113912-Hillroom_AsistCare_izquierda.png"
},
{
    "_id": {
        "$oid": "66fec150c23df6e7b81fb926"
    },
    "nombre": "Teclado Stryker FL28",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker FL28",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1724250780342-Stryker_FL28.png"
},
{
    "_id": {
        "$oid": "67a3d527a5cce5fe09002a5f"
    },
    "nombre": "Teclado GE Silhouette-Vr",
    "descripcion": "Teclado de membrana compatible con rayos X GE Silhouette-Vr",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739385642228-GE_Silhouette_VR.jpg"
},
{
    "_id": {
        "$oid": "67a3dceba5cce5fe09002ae1"
    },
    "nombre": "Teclado Braxa",
    "descripcion": "Teclado de membrana compatible con lámpara quirúrgica Braxa",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739386321358-lampara_Braxa.jpg"
},
{
    "_id": {
        "$oid": "67a3ddbea5cce5fe09002af9"
    },
    "nombre": "Teclado Trumpf Mars",
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Trumpf Mars",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739389722833-Trumpf_Mars_v1.jpg"
},
{
    "_id": {
        "$oid": "67a3de5fa5cce5fe09002b14"
    },
    "nombre": "Teclado Medix PC-305",
    "descripcion": "Teclado de membrana compatible con Medix PC-305",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739396396406-medix_pc-305.jpg"
},
{
    "_id": {
        "$oid": "67a3df74a5cce5fe09002b38"
    },
    "nombre": "Teclado Valleylab Force 40 (modelo 1)",
    "descripcion": "Teclado de membrana compatible con electrobisturí Valleylab Force 40 (modelo 1)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726588344971-force403btn.png"
},
{
    "_id": {
        "$oid": "67a3dff3a5cce5fe09002b5a"
    },
    "nombre": "Teclado Valleylab Force 40 (modelo 2)",
    "descripcion": "Teclado de membrana compatible con electrobisturí Valleylab Force 40 (modelo 2)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726588356545-force405btn.png"
},
{
    "_id": {
        "$oid": "67a3e072a5cce5fe09002b8f"
    },
    "nombre": "Teclado Valleylab Force 40 (modelo 3)",
    "descripcion": "Teclado de membrana compatible con electrobisturí Valleylab Force 40 (modelo 3)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1726588366171-force4010btn.png"
},
{
    "_id": {
        "$oid": "67a3e126a5cce5fe09002bb3"
    },
    "nombre": "Teclado Comen CM100",
    "descripcion": "Teclado de membrana compatible con electrocardiógrafo Comen CM100",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739398288072-commen_cm100.jpg"
},
{
    "_id": {
        "$oid": "67a3e1e7a5cce5fe09002c06"
    },
    "nombre": "Teclado Klemsan",
    "descripcion": "Teclado de membrana compatible con plotter Klemsan",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739398926001-plotter_klemsan.jpg"
},
{
    "_id": {
        "$oid": "67a3e2a5a5cce5fe09002c3b"
    },
    "nombre": "Teclado plotter de corte",
    "descripcion": "Teclado compatible con plotter de corte",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739399141597-plotter_corte.jpg"
},
{
    "_id": {
        "$oid": "67a3e4f7a5cce5fe09002c75"
    },
    "nombre": "Teclado Coviden Kendall SCD",
    "descripcion": "Teclado de membrana compatible con sistema de compresión Coviden Kendall SCD",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739399368910-Coviden_Kendall_SCD.jpg"
},
{
    "_id": {
        "$oid": "67a3e610a5cce5fe09002c8d"
    },
    "nombre": "Teclado Carefusion Nicolet Viking Quest",
    "descripcion": "Teclado de membrana compatible con electromiografía Carefusion Nicolet Viking Quest",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739399644669-Carefusion_Nicolet_Viking_Quest.jpg"
},
{
    "_id": {
        "$oid": "67a4ddbca5cce5fe09002f5d"
    },
    "nombre": "Teclado Mettler Electronics SYS STIM 226",
    "descripcion": "Teclado de membrana compatible con electro estimulador neuromuscular Mettler Electronics SYS STIM 226",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739398651498-SysStim226.jpg"
},
{
    "_id": {
        "$oid": "67a4e692a5cce5fe09002f80"
    },
    "nombre": "Teclado GE Ohmeda Ohio Care Plus 4000",
    "descripcion": "Teclado de membrana compatible con incubadora neonatal GE Ohmeda Ohio Care Plus 4000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739484634870-GE_Ohmeda_Ohio_Care_Plus_4000.jpg"
},
{
    "_id": {
        "$oid": "67ae726d7e093fdca99d50ce"
    },
    "nombre": "Teclado Rimsa U29",
    "descripcion": "Teclado de membrana compatible con lámpara quirúrgica Rimsa U29",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739804675460-Rimsa_U29.jpg"
},
{
    "_id": {
        "$oid": "67ae73287e093fdca99d50e9"
    },
    "nombre": "Teclado Steris XLED 3",
    "descripcion": "Teclado de membrana compatible con lámpara quirúrgica Steris XLED 3",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739804964630-Steris_XLED_3.jpg"
},
{
    "_id": {
        "$oid": "67ae744a7e093fdca99d514a"
    },
    "nombre": "Teclado RichMar Therasound 3.5",
    "descripcion": "Teclado de membrana compatible con ultrasonido portátil RichMar Therasound 3.5",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739805926899-RichMar_Therasound.jpg"
},
{
    "_id": {
        "$oid": "67b391bd7e093fdca99d5b05"
    },
    "nombre": "Teclado Mettler Electronics SYS STIM 206",
    "descripcion": "Teclado de membrana compatible con electro estimulador neuromuscular Mettler Electronics SYS STIM 206",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739839086036-SYS_STIM_206.jpg"
},
{
    "_id": {
        "$oid": "67b4a1007e093fdca99d5bb6"
    },
    "nombre": "Teclado Zimmer ATS 1200",
    "descripcion": "Teclado de membrana compatible con torniquete Zimmer ATS 1200",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739891166749-Zimmer_ATS_1200.jpg"
},
{
    "_id": {
        "$oid": "67b4fc3a7e093fdca99d5eba"
    },
    "nombre": "Teclado Mettler Electronics Sonicator Plus 930",
    "descripcion": "Teclado de membrana compatible con ultrasonido terapéutico y estimulador muscular Mettler Electronics Sonicator Plus 930",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739897812095-Sonicator_930_Plus.jpg"
},
{
    "_id": {
        "$oid": "67b4ffa17e093fdca99d5ece"
    },
    "nombre": "Teclado Wiener Lab. Metrolab 1600 DR",
    "descripcion": "Teclado de membrana compatible con analizador clínico semiautomático Wiener Lab. Metrolab 1600 DR",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739915113849-Metrolab_1600_DR.jpg"
},
{
    "_id": {
        "$oid": "67b64f3f7e093fdca99d62d2"
    },
    "nombre": "Teclado Schmitz Diamond",
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Schmitz Diamond",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739918981025-Schmitz_Diamond_50BK.jpg"
},
{
    "_id": {
        "$oid": "67be0ffb7e093fdca99d704a"
    },
    "nombre": "Teclado Trumpf Mars",
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Trumpf Mars",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740509490283-Trumpf_Mars_v2.jpg"
},
{
    "_id": {
        "$oid": "67bf4a647e093fdca99d741a"
    },
    "nombre": "Teclado Esco Streamline Clase II",
    "descripcion": "Teclado de membrana compatible con cabina de seguridad biológica Esco Streamline Clase II",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740590818983-Esco_Streamline.jpg"
},
{
    "_id": {
        "$oid": "67bf53357e093fdca99d7456"
    },
    "nombre": "Teclado Malvestio GAMMA 3",
    "descripcion": "Teclado de membrana compatible con mesa de cirugía Malvestio GAMMA 3",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740591904822-Malvestio_Gamma3.jpg"
},
{
    "_id": {
        "$oid": "67bf55d67e093fdca99d746a"
    },
    "nombre": "Teclado Presvac DP-2065 12B",
    "descripcion": "Teclado de membrana compatible con centrífuga refrigerada microprocesada Presvac DP-2065 12B",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740592577009-Presvac_DP-2065.jpg"
},
{
    "_id": {
        "$oid": "67bf58d97e093fdca99d7487"
    },
    "nombre": "Teclado PackLab",
    "descripcion": "Teclado de membrana compatible con etiquetadora PackLab",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740593329874-PackLab.jpg"
},
{
    "_id": {
        "$oid": "67bf5b697e093fdca99d749c"
    },
    "nombre": "Teclado Fagor Advance AD-9",
    "descripcion": "Teclado de membrana compatible con lavavajillas Fagor Advance AD-9",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740594009799-Fagor_Advance_AD-9.jpg"
},
{
    "_id": {
        "$oid": "67bf61727e093fdca99d74dc"
    },
    "nombre": "Teclado Normalab NSB TECH",
    "descripcion": "Teclado de membrana compatible con analizador de aceite Normalab NSB TECH",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740604730788-Normalab_NSB_TECH.jpg"
},
{
    "_id": {
        "$oid": "67bf84657e093fdca99d74ff"
    },
    "nombre": "Teclado Jeneric/Pentron Auto Press Plus",
    "descripcion": "Teclado de membrana compatible con horno de laboratorio dental Jeneric/Pentron Auto Press Plus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740604507992-JenericPentron_AutoPressPlus.jpg"
},
{
    "_id": {
        "$oid": "67bf8a507e093fdca99d755f"
    },
    "nombre": "Teclado Smiths Medical BCI Advisor",
    "descripcion": "Teclado de membrana compatible con monitor de signos vitales Smiths Medical BCI Advisor",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740606010458-SmithsMedical_BCIAdvisor.jpg"
},
{
    "_id": {
        "$oid": "67bf8f8d7e093fdca99d7575"
    },
    "nombre": "Teclado DV Power RMO-A",
    "descripcion": "Teclado de membrana compatible con microohmímetro DV Power RMO-A",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740607360058-DVPower_RMO-A.jpg"
},
{
    "_id": {
        "$oid": "67c096c07e093fdca99d7653"
    },
    "nombre": "Teclado Löwenstein Medical Leoni plus",
    "descripcion": "Teclado de membrana compatible con ventilador Löwenstein Medical Leoni plus",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740675234307-LowensteinMedical_LeoniPlus.jpg"
},
{
    "_id": {
        "$oid": "67c0a1d27e093fdca99d76cc"
    },
    "nombre": "Teclado Savion",
    "descripcion": "Teclado de membrana compatible con lámpara quirúrgica Savion",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740677392400-Lampara_savion.jpg"
},
{
    "_id": {
        "$oid": "67c0a5d07e093fdca99d76e1"
    },
    "nombre": "Teclado eVent Medical Inspiration LS",
    "descripcion": "Teclado de membrana compatible con ventilador eVent Medical Inspiration LS",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740678478061-eVentMedical_InspirationLS.jpg"
},
{
    "_id": {
        "$oid": "67c0ace37e093fdca99d76f9"
    },
    "nombre": "Teclado Medidata MED-200/400",
    "descripcion": "Teclado de membrana compatible con báscula digital Medidata MED-200/400",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740680396961-Medidata_MED-200-400.jpg"
},
{
    "_id": {
        "$oid": "67c0bb817e093fdca99d7774"
    },
    "nombre": "Teclado Welch-Allyn Connex ProBP 3400",
    "descripcion": "Teclado de membrana compatible con dispositivo de tensión arterial Welch-Allyn Connex ProBP 3400",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740684150992-Welch-Allyn_ConnexProBP3400.jpg"
},
{
    "_id": {
        "$oid": "67c0c0207e093fdca99d7811"
    },
    "nombre": "Teclado SciCan Statim Classic 2000S",
    "descripcion": "Teclado de membrana compatible con esterilizador SciCan Statim Classic 2000S",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740685317949-SciCan_StatimClassic2000S.jpg"
},
{
    "_id": {
        "$oid": "67c0c2b97e093fdca99d7825"
    },
    "nombre": "Teclado Natus Dantec Clavis",
    "descripcion": "Teclado de membrana compatible con dispositivo portátil para inyecciones guiadas de EMG/STIM Natus Dantec Clavis",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1740685997708-Natus_DantecClavis.jpg"
},
{
    "_id": {
        "$oid": "67c2072c7e093fdca99d7b72"
    },
    "nombre": "Teclado AeonMed OP850",
    "descripcion": "Teclado de membrana compatible con mesa de cirugía AeonMed OP850",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741112548550-Aeomed_OP850.jpg"
},
{
    "_id": {
        "$oid": "67c775b17e093fdca99d82f2"
    },
    "nombre": "Teclado Berchtold Chromophare",
    "descripcion": "Teclado de membrana compatible con lámpara de quirófano Berchtold Chromophare",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741125032494-Berchtold_Chromophare.jpg"
},
{
    "_id": {
        "$oid": "67c77a267e093fdca99d8312"
    },
    "nombre": "Teclado Risco RS-105",
    "descripcion": "Teclado de membrana compatible con embutidora Risco RS-105",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741125717412-Risco_RS-105.jpg"
},
{
    "_id": {
        "$oid": "67c7823d7e093fdca99d832f"
    },
    "nombre": "Teclado Stryker FL28 (exterior derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker FL28 (barandal exterior derecho)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741199243493-Stryker_FL28_exterior-derecha.jpg"
},
{
    "_id": {
        "$oid": "67c783197e093fdca99d836c"
    },
    "nombre": "Teclado Stryker FL28 (exterior izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker FL28 (barandal exterior izquierdo)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741200185271-Stryker_FL28_exterior-izquierda.jpg"
},
{
    "_id": {
        "$oid": "67c783cb7e093fdca99d8390"
    },
    "nombre": "Teclado Stryker FL28 (interior derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker FL28 (barandal interior derecho)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741202451894-Stryker_FL28_interior-derecha.jpg"
},
{
    "_id": {
        "$oid": "67c88a907e093fdca99d8429"
    },
    "nombre": "Teclado Stryker FL28 (interior izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker FL28 (barandal interior izquierdo)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741202595292-Stryker_FL28_interior-izquierda.jpg"
},
{
    "_id": {
        "$oid": "67c8c4b77e093fdca99d85e2"
    },
    "nombre": "Teclado Siare Siaretron 1000 IPER",
    "descripcion": "Teclado de membrana compatible con ventilador Siare Siaretron 1000 IPER",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741210570360-Siare_Siaretron1000-IPER.jpg"
},
{
    "_id": {
        "$oid": "67c8c7ce7e093fdca99d8603"
    },
    "nombre": "Teclado Siare Siaretron 4000",
    "descripcion": "Teclado de membrana compatible con ventilador Siare Siaretron 4000",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741211582352-Siare_Siaretron4000.jpg"
},
{
    "_id": {
        "$oid": "67c8cd1b7e093fdca99d8630"
    },
    "nombre": "Teclado Siare Morpheus ND HYBRID",
    "descripcion": "Teclado de membrana compatible con maquina de anestesia Siare Morpheus ND HYBRID",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741212802284-Siare_MorpheusND-HYBRID.jpg"
},
{
    "_id": {
        "$oid": "67c8d2137e093fdca99d8689"
    },
    "nombre": "Teclado Savion",
    "descripcion": "Teclado de membrana compatible con lámpara quirúrgica Savion",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741213853048-Lampara_savion_v2.jpg"
},
{
    "_id": {
        "$oid": "67c9bd197e093fdca99d878d"
    },
    "nombre": "Teclado Mettler Electronics Sys Stim 540",
    "descripcion": "Teclado de membrana compatible con láser infrarrojo Mettler Electronics Sys Stim 540",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741274384889-MettlerElectronics_SysStim540.jpg"
},
{
    "_id": {
        "$oid": "67cf29dd7e093fdca99d8fec"
    },
    "nombre": "Teclado Paramount Bed Serie A5 (exterior derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Paramount Bed Serie A5 (exterior derecha)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739303342483-paramount_bed_derecha_grande.jpg"
},
{
    "_id": {
        "$oid": "67cf2aed7e093fdca99d9021"
    },
    "nombre": "Teclado Paramount Bed Serie A5 (interior derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Paramount Bed Serie A5 (interior derecha)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1739303433003-paramount_bed_derecha_chica.jpg"
},
{
    "_id": {
        "$oid": "67cf2c2c231cfff24e11e572"
    },
    "nombre": "Teclado Paramount Bed Serie A5 (exterior izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Paramount Bed Serie A5 (exterior izquierda)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741631430336-ParamountBed_SerieA5-extIzquierda.jpg"
},
{
    "_id": {
        "$oid": "67cf2c55231cfff24e11e573"
    },
    "nombre": "Teclado Paramount Bed Serie A5 (interior izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Paramount Bed Serie A5 (interior izquierda)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1741632040018-ParamountBed_SerieA5-intIzquierda.jpg"
},
{
    "_id": {
        "$oid": "67db1e487e093fdca99da5a2"
    },
    "nombre": "Teclado Pardo HiTech (derecha)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Pardo HiTech (derecha)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1742414066515-Pardo_HiTech-derecha.jpg"
},
{
    "_id": {
        "$oid": "67db1ebb6bbc7f8849a3e1a4"
    },
    "nombre": "Teclado Pardo HiTech (izquierda)",
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Pardo HiTech (izquierda)",
    "categoria": "Teclados de membrana",
    "imagen": "https://sistema.juvalfri.com/1742414096291-Pardo_HiTech-izquierda.jpg"
}];

export const membranasData = [{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da9"
    },
    "descripcion": "Membrana compatible con monitor fetal Bionet FC700",
    "nombre": "Membrana Bionet FC700",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844311130-ME001.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414daa"
    },
    "descripcion": "Membrana compatible con monitor fetal Philips Serie 50 A",
    "nombre": "Membrana Philips Serie 50 A",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844380235-ME002.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dab"
    },
    "descripcion": "Membrana compatible con unidad dental Rojas Dent",
    "nombre": "Membrana Rojas Dent",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844460778-ME003.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dac"
    },
    "descripcion": "Membrana compatible con mesa de cirugía Sismatec Mastertec",
    "nombre": "Membrana Sismatec Mastertec",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844576975-ME004.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dad"
    },
    "descripcion": "Membrana compatible con el control de mano para mesa de cirugía Sismatec Mastertec",
    "nombre": "Membrana Control Sismatec Mastertec",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844633044-ME005.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dae"
    },
    "descripcion": "Membrana compatible con cama eléctrica Hill Rom 405 (juego 6 piezas)",
    "nombre": "Membrana Hill Rom 405 (juego 6 piezas)",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707844945422-ME006.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414daf"
    },
    "descripcion": "Membrana compatible con centrifuga Beckman Coulter Allegra",
    "nombre": "Membrana Beckman Coulter Allegra",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845192795-ME007.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db0"
    },
    "descripcion": "Membrana compatible con desfibrilador Welch Allyn MRL",
    "nombre": "Membrana Welch Allyn MRL",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845293983-ME008.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db1"
    },
    "descripcion": "Membrana compatible con cama eléctrica Stryker MPS 3000",
    "nombre": "Membrana Stryker MPS 3000",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845502948-ME009.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db2"
    },
    "descripcion": "Membrana compatible con ultrasonido Shimadzu SDU-350XL",
    "nombre": "Membrana Shimadzu SDU-350XL",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845618685-ME010.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db3"
    },
    "descripcion": "Membrana compatible con ultrasonido General Electric Logiq 200",
    "nombre": "Membrana GE LOGIQ 200",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845708802-ME011.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db4"
    },
    "descripcion": "Membrana compatible con rayos X mobil TMS 300",
    "nombre": "Membrana TMS 300",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845806362-ME012.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db5"
    },
    "descripcion": "Membrana compatible con monitor de signos vitales Space Lab Mcare 300",
    "nombre": "Membrana Space Lab Mcare 300",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707845886430-ME013.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db6"
    },
    "descripcion": "Membrana compatible con el control de mano para actuador lineal L&K HB 33-00",
    "nombre": "Membrana L&K HB 33-00",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1707846207922-ME014.jpg"
},
{
    "_id": {
        "$oid": "66d0ad88bdfd1d6056aac28d"
    },
    "nombre": "Membrana 405 Mod 1",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 1",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724950756419-HR405_Mod1.png"
},
{
    "_id": {
        "$oid": "66d0adedbdfd1d6056aac2a1"
    },
    "nombre": "Membrana 405 Mod 2",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 2",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724951063404-HR405_Mod2.png"
},
{
    "_id": {
        "$oid": "66d0ae29bdfd1d6056aac2af"
    },
    "nombre": "Membrana 405 Mod 3",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 3",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724951070196-HR405_Mod3.png"
},
{
    "_id": {
        "$oid": "66d0ae69bdfd1d6056aac2c4"
    },
    "nombre": "Membrana 405 Mod 4",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 4",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724951076056-HR405_Mod4.png"
},
{
    "_id": {
        "$oid": "66d0aeb4bdfd1d6056aac2d1"
    },
    "nombre": "Membrana 405 Mod 5",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 5",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724951082659-HR405_Mod5.png"
},
{
    "_id": {
        "$oid": "66d0af07bdfd1d6056aac2e0"
    },
    "nombre": "Membrana 405 Mod 6",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom 405 Modelo 6",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1724951089568-HR405_Mod6.png"
},
{
    "_id": {
        "$oid": "67ca1e437e093fdca99d891d"
    },
    "nombre": "Membrana Lupetec BH2015",
    "descripcion": "Membrana compatible con baño histológico Lupetec BH2015",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741299241876-Lupetec_BH2015.jpg"
},
{
    "_id": {
        "$oid": "67ca20517e093fdca99d8930"
    },
    "nombre": "Membrana Bionet FC1400",
    "descripcion": "Membrana compatible con monitor fetal Bionet FC1400",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741299677171-Bionet_FC1400.jpg"
},
{
    "_id": {
        "$oid": "67ca227f7e093fdca99d8968"
    },
    "nombre": "Membrana Datex Ohmeda Cardiocap/5 (V1)",
    "descripcion": "Membrana compatible con monitor de signos vitales Datex Ohmeda Cardiocap/5",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741366094544-DatexOhmeda_Cardiocap5-V1.jpg"
},
{
    "_id": {
        "$oid": "67ca260bf1ded82b5314cf35"
    },
    "nombre": "Membrana Datex Ohmeda Cardiocap/5 (V2)",
    "descripcion": "Membrana compatible con monitor de signos vitales Datex Ohmeda Cardiocap/5",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741366523504-DatexOhmeda_Cardiocap5-V2.jpg"
},
{
    "_id": {
        "$oid": "67ca261bf1ded82b5314cf36"
    },
    "nombre": "Membrana Datex Ohmeda Cardiocap/5 (V3)",
    "descripcion": "Membrana compatible con monitor de signos vitales Datex Ohmeda Cardiocap/5",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741366702569-DatexOhmeda_Cardiocap5-V3.jpg"
},
{
    "_id": {
        "$oid": "67cb2d327e093fdca99d8a92"
    },
    "nombre": "Membrana Fanem 1186",
    "descripcion": "Membrana compatible con incubadora neonatal Fanem 1186",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1725392259423-fanem.png"
},
{
    "_id": {
        "$oid": "67cb37247a08eb2fe3fe1874"
    },
    "nombre": "Membrana Philips VMI Compacto Plus 500",
    "descripcion": "Membrana compatible con equipo de Rayos X Philips VMI Compacto Plus 500",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741371160917-Philips_VMICompactoPlus500.jpg"
},
{
    "_id": {
        "$oid": "67cb3cad7a08eb2fe3fe1875"
    },
    "nombre": "Membrana DRGEM GXR–S",
    "descripcion": "Membrana compatible con equipo de Rayos X DRGEM GXR-S",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741372570684-DRGEM_GXR-S.jpg"
},
{
    "_id": {
        "$oid": "67cb3f0b7a08eb2fe3fe1876"
    },
    "nombre": "Membrana Megger OTS60SX/2",
    "descripcion": "Membrana compatible con probador de aceite semiautomático Megger OTS60SX/2",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741373169131-Megger_OTS60SX-2.jpg"
},
{
    "_id": {
        "$oid": "67cb41267a08eb2fe3fe1877"
    },
    "nombre": "Membrana Transcell Technology TI-500 SL",
    "descripcion": "Membrana compatible con panel de báscula Transcell Technology TI-500 SL",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741373713271-TranscellTechnology_TI-500SL.jpg"
},
{
    "_id": {
        "$oid": "67cb74287a08eb2fe3fe1878"
    },
    "nombre": "Membrana GE Senographe DMR",
    "descripcion": "Membrana compatible con mamógrafo GE Senographe DMR",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741386755417-GE_SenographeDMR.jpg"
},
{
    "_id": {
        "$oid": "67cf6c517e093fdca99d925f"
    },
    "nombre": "Membrana Quantum Medical Imaging INDi XL Series",
    "descripcion": "Membrana compatible con generador de alta frecuencia para rayos X Quantum Medical Imaging INDi XL Series",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741874264173-QuantumMedicalImaging_INDiXLSeries.jpg"
},
{
    "_id": {
        "$oid": "67cf6d027e093fdca99d9290"
    },
    "nombre": "Membrana Air-Shields Ti500",
    "descripcion": "Membrana compatible con incubadora de transporte Air-Shields Ti500",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741875948049-Air-Shields_Ti500.jpg"
},
{
    "_id": {
        "$oid": "67d211ae7e093fdca99d9711"
    },
    "nombre": "Membrana Ritter",
    "descripcion": "Membrana compatible con unidad dental Ritter",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741820315933-Ritter.jpg"
},
{
    "_id": {
        "$oid": "67d2efb57e093fdca99d97c9"
    },
    "nombre": "Membrana WEM SS-501s",
    "descripcion": "Membrana compatible con Electrocauterio WEM SS-501s",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741877098131-wem_SS-501s.jpg"
},
{
    "_id": {
        "$oid": "67d353f37e093fdca99d9b16"
    },
    "nombre": "Membrana Berchtold Operon B810",
    "descripcion": "Membrana compatible con mesa de cirugía Berchtold Operon B810",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741902665655-Berchtold_OperonB810.jpg"
},
{
    "_id": {
        "$oid": "67d359577e093fdca99d9b53"
    },
    "nombre": "Membrana Nellcor N560",
    "descripcion": "Membrana compatible con pulsioxímetro Nellcor N560",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1741903669307-Nellcor_N560.jpg"
},
{
    "_id": {
        "$oid": "67d991377e093fdca99d9e6b"
    },
    "nombre": "Membrana Hill Rom Advanta P1600",
    "descripcion": "Membrana compatible con cama hospitalaria Hill Rom Advanta P1600",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742311102113-HillRoom_AdvantaP1600.jpg"
},
{
    "_id": {
        "$oid": "67d9a15e7e093fdca99d9f36"
    },
    "nombre": "Membrana Proemier (V1)",
    "descripcion": "Membrana compatible con lámpara de quirófano Proemier (V1)",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742315856923-Proemier_V1.jpg"
},
{
    "_id": {
        "$oid": "67d9c5291c0963a7113548dd"
    },
    "nombre": "Membrana Proemier (V2)",
    "descripcion": "Membrana compatible con lámpara de quirófano Proemier (V2)",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742325181972-Proemier_V2.jpg"
},
{
    "_id": {
        "$oid": "67d9de801c0963a7113548de"
    },
    "nombre": "Membrana Stryker Sonopet",
    "descripcion": "Membrana compatible con aspirador ultrasonico Stryker Sonopet",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742331566780-Stryker_sonopet.jpg"
},
{
    "_id": {
        "$oid": "67d9e0b61c0963a7113548df"
    },
    "nombre": "Membrana Arjo Huntleigh Enterprise 5000",
    "descripcion": "Membrana compatible con cama hospitalaria Arjo Huntleigh Enterprise 5000",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742332370188-ArjoHuntleigh_Enterprise5000.jpg"
},
{
    "_id": {
        "$oid": "67d9e5861c0963a7113548e0"
    },
    "nombre": "Membrana Dison BL-50D",
    "descripcion": "Membrana compatible con unidad de fototerapia infantil Dison BL-50D",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742333306025-Dison_BL-50D.jpg"
},
{
    "_id": {
        "$oid": "67d9f0a21c0963a7113548e1"
    },
    "nombre": "Membrana AeonMed OP850 Control",
    "descripcion": "Membrana compatible con control de mesa de cirugía AeonMed OP850",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742336142901-AeonMed_OP850-control.jpg"
},
{
    "_id": {
        "$oid": "67db150e7e093fdca99da51d"
    },
    "nombre": "Membrana Xiamen Senyang APM-P06B",
    "descripcion": "Membrana compatible con colchón de presión alternante Xiamen Senyang APM-P06B",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742412648240-XiamenSenyang_APM-P06B.jpg"
},
{
    "_id": {
        "$oid": "67db3bad6bbc7f8849a3e1a5"
    },
    "nombre": "Membrana Toshiba Capasee",
    "descripcion": "Membrana compatible con ultrasonido portatil Toshiba Capasee",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742420873543-Toshiba_capasee.jpg"
},
{
    "_id": {
        "$oid": "67db438f7e093fdca99da68f"
    },
    "nombre": "Membrana Nihon Kohden Cardiolife (palas)",
    "descripcion": "Membrana compatible con palas de desfibrilador Nihon Kohden Cardiolife",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742422919935-Nihon Kohden Cardiolife.jpg"
},
{
    "_id": {
        "$oid": "67db45426bbc7f8849a3e1a6"
    },
    "nombre": "Membrana Philips PageWriter 200 M1770",
    "descripcion": "Membrana compatible con electrocardiógrafo Philips PageWriter 200 M1770",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742423345515-Philips_PageWriter200M1770.jpg"
},
{
    "_id": {
        "$oid": "67db49c76bbc7f8849a3e1a7"
    },
    "nombre": "Membrana Lorma AV-29",
    "descripcion": "Membrana compatible con autoclave Lorma AV-29",
    "categoria": "Membranas",
    "imagen": "https://sistema.juvalfri.com/1742424501933-Lorma_AV-29.jpg"
}];

export const refaccionesData = [{
    "_id": {
        "$oid": "663bb9d37d549597b8235f0b"
    },
    "nombre": "Soporte para piernera/bracera Mod1",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 30 mm de altura con 10 mm de espesor.",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715190101123-Soporte-piernera-2.png"
},
{
    "_id": {
        "$oid": "663bbbb57d549597b8235f60"
    },
    "nombre": "Soporte para piernera/bracera Mod2",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 30 mm de altura con 10 mm de espesor.",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715190383828-Soporte-piernera-1.png"
},
{
    "_id": {
        "$oid": "663bbc357d549597b8236027"
    },
    "nombre": "Soporte para piernera/bracera Mod3",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 31 mm de altura con 11 mm de espesor.",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715190393733-Soporte-piernera-4.png"
},
{
    "_id": {
        "$oid": "663bc0517d549597b823628d"
    },
    "nombre": "Cople para motor Hill Rom",
    "descripcion": "Cople para motor de cama hospitalaria Hill Rom",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715191177444-hillromblanco.png"
},
{
    "_id": {
        "$oid": "663bc1527d549597b82362a7"
    },
    "nombre": "Galleta Hill Rom",
    "descripcion": "Galleta de neopreno para cople de motor Hill Rom ",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715191926986-WhatsApp Image 2024-02-21 at 1.30.54 PM (1).jpeg"
},
{
    "_id": {
        "$oid": "663bc61a7d549597b823644f"
    },
    "nombre": "Pieza de nylamid superior cople Hill Rom",
    "descripcion": "Pieza superior de nylamid para cople de motor Hill Rom",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715198069327-coplesup.jpeg"
},
{
    "_id": {
        "$oid": "663bd9a17d549597b823698b"
    },
    "nombre": "Pieza de nylamid inferior cople Hill Rom",
    "descripcion": "Pieza inferior de nylamid para cople de motor Hill Rom",
    "categoria": "Refacciones",
    "imagen": "https://sistema.juvalfri.com/1715198101949-copleinf.jpeg"
}]

export const ruedasData = [{
    "_id": {
        "$oid": "66886f93b0a2b1bfa7888247"
    },
    "nombre": "Rueda Stryker 8",
    "descripcion": "Rueda de repuesto de 8\" para cama Stryker / ancho rueda 32 mm, longitud del cubo 54 mm, diámetro del eje 11 mm. ",
    "categoria": "Ruedas",
    "imagen": "https://sistema.juvalfri.com/1720214490447-Stryker.jpeg"
},
{
    "_id": {
        "$oid": "668871e4b0a2b1bfa7888253"
    },
    "nombre": "Rueda Haion 200",
    "descripcion": "Rueda de repuesto de 200 mm para cama Haion / ancho de la rueda 32 mm, longitud del cubo 38 mm, diámetro del eje 8 mm.",
    "categoria": "Ruedas",
    "imagen": "https://sistema.juvalfri.com/1720214480474-RuedaHaion200.jpeg"
},
{
    "_id": {
        "$oid": "66887408b0a2b1bfa7888265"
    },
    "nombre": "Rueda Caster 6\"",
    "descripcion": "Rueda de repuesto de 6\" / ancho de la rueda de 50.8 mm, longitud del cubo 62.8 mm, diámetro del eje 13 mm",
    "categoria": "Ruedas",
    "imagen": "https://sistema.juvalfri.com/1720218266936-Caster6.jpeg"
},
{
    "_id": {
        "$oid": "671682c8c23df6e7b81fe052"
    },
    "nombre": "Rueda Haion 125mm / 5\"",
    "descripcion": "Rueda doble con freno externo total de 125mm (5\") sujeción tipo tornillo M12 P=1.75",
    "categoria": "Ruedas",
    "imagen": "https://sistema.juvalfri.com/1727718730654-HAION_E322_4T125UNBN.png"
},
{
    "_id": {
        "$oid": "67168341c23df6e7b81fe067"
    },
    "nombre": "Rueda Haion 120mm / 4\"",
    "descripcion": "Rueda doble con freno externo total de 100mm (4\") sujeción tipo tornillo M12 P=1.75",
    "categoria": "Ruedas",
    "imagen": "https://sistema.juvalfri.com/1727722206877-HAION_E322_4T100UNBN.png"
}];

export const amortiguadoresData = [{
    "_id": {
        "$oid": "668824b18e6dbe95e82a7c8b"
    },
    "nombre": "Amortiguador 100N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 100N Mod. 4748LA / Carrera 36 cm, longitud total 94 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720198301690-100N.png"
},
{
    "_id": {
        "$oid": "66882dd38e6dbe95e82a7d1d"
    },
    "nombre": "Amortiguador 200N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 200N Mod. 682969 / Carrera 8 cm, longitud total 31 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200230703-200N.png"
},
{
    "_id": {
        "$oid": "66882fe48e6dbe95e82a7d32"
    },
    "nombre": "Amortiguador 240N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 240N Mod. 1932CB / Carrera 19 cm, longitud total 57 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200240825-240N.png"
},
{
    "_id": {
        "$oid": "6688308c8e6dbe95e82a7d3e"
    },
    "nombre": "Amortiguador 250N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 250N Mod. 4665RN / Carrera 19 cm, longitud total 57 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200248552-250N.png"
},
{
    "_id": {
        "$oid": "668832fe8e6dbe95e82a7d63"
    },
    "nombre": "Amortiguador 300N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 300N Mod. 869856 / Carrera 19 cm, longitud total 57 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200258044-300N.png"
},
{
    "_id": {
        "$oid": "668833908e6dbe95e82a7d6f"
    },
    "nombre": "Amortiguador 400N (5413H5)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 400N Mod. 5413H5 / Carrera 25 cm, longitud total 73 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200265413-400N.png"
},
{
    "_id": {
        "$oid": "668834048e6dbe95e82a7d7b"
    },
    "nombre": "Amortiguador 400N (729531)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 400N Mod. 729531 / Carrera 10 cm, longitud total 31 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200288811-400N_2.png"
},
{
    "_id": {
        "$oid": "668834bd8e6dbe95e82a7d8f"
    },
    "nombre": "Amortiguador 400N (729698)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 400N Mod. 729698 / Carrera 16 cm, longitud total 43 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200298946-400N_3.png"
},
{
    "_id": {
        "$oid": "668835758e6dbe95e82a7db5"
    },
    "nombre": "Amortiguador 400N (732052)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 400N Mod. 732052 / Carrera 8 cm, longitud total 31 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200315050-400N_4.png"
},
{
    "_id": {
        "$oid": "668835eb8e6dbe95e82a7dc1"
    },
    "nombre": "Amortiguador 400N (732311)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 400N Mod. 732311 / Carrera 16 cm, longitud total 51 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200326449-400N_5.png"
},
{
    "_id": {
        "$oid": "66883a738e6dbe95e82a7e0d"
    },
    "nombre": "Amortiguador 420N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 420N Mod. 2913MO / Carrera 7.5 cm, longitud total 27 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200333507-420N.png"
},
{
    "_id": {
        "$oid": "66883e918e6dbe95e82a7e1b"
    },
    "nombre": "Amortiguador 500N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 500N Mod. 4719LN / Carrera 20 cm, longitud total 60 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200346563-500N.png"
},
{
    "_id": {
        "$oid": "66883f708e6dbe95e82a7e32"
    },
    "nombre": "Amortiguador 600N (8026QT)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 600N Mod. 8026QT / Carrera 2 cm, longitud total 24.5 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200358237-600N.png"
},
{
    "_id": {
        "$oid": "66883fd08e6dbe95e82a7e3e"
    },
    "nombre": "Amortiguador 600N (729477)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 600N Mod. 729477 / Carrera 8.2 cm, longitud total 26.9 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200367758-600N_2.png"
},
{
    "_id": {
        "$oid": "668840308e6dbe95e82a7e4a"
    },
    "nombre": "Amortiguador 600N (732192)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 600N Mod. 732192 / Carrera 12 cm, longitud total 42 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200377626-600N_3.png"
},
{
    "_id": {
        "$oid": "668840ef8e6dbe95e82a7e6b"
    },
    "nombre": "Amortiguador 720N",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 720N Mod. 3365EN / Carrera 19 cm, longitud total 55 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200390076-720.png"
},
{
    "_id": {
        "$oid": "668841c98e6dbe95e82a7e77"
    },
    "nombre": "Amortiguador 1000N (729566)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 1000N Mod. 729566 / Carrera 10 cm, longitud total 31 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200404048-1000N.png"
},
{
    "_id": {
        "$oid": "668842328e6dbe95e82a7e83"
    },
    "nombre": "Amortiguador 1000N (732133)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 1000N Mod. 732133 / Carrera 12 cm, longitud total 37 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200441581-1000N_2.png"
},
{
    "_id": {
        "$oid": "668842ae8e6dbe95e82a7e96"
    },
    "nombre": "Amortiguador 1000N (732346)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 1000N Mod. 732346 / Carrera 16 cm, longitud total 51 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200450385-1000N_3.png"
},
{
    "_id": {
        "$oid": "6688430e8e6dbe95e82a7ea2"
    },
    "nombre": "Amortiguador 1000N (732400)",
    "descripcion": "Amortiguador Stabilus Bloc O Lift 1000N Mod. 732400 / Carrera 20 cm, longitud total 60 cm",
    "categoria": "Amortiguadores",
    "imagen": "https://sistema.juvalfri.com/1720200458151-1000N_4.png"
}]

const destacadosData = [{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dc6"
    },
    "descripcion": "Bandeja para impresora de desfibrilador Zoll, incluye etiquetas.",
    "nombre": "Bandeja Zoll con etiquetas",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1718059396561-BZoll.png"
},
{
    "_id": {
        "$oid": "6674b20c8e6dbe95e82a58a9"
    },
    "nombre": "Carcasa superior Zoll con asa de transporte",
    "descripcion": "Carcasa superior Zoll con asa de transporte, compatible con el modelo M Series.",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1718915144289-DZ.jfif"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dd4"
    },
    "descripcion": "Tapa compatible con impresora de desfibrilador Philips HeartStart XL. Incluye etiqueta.",
    "nombre": "Tapa Heartstart con etiquetas",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1720191687088-tapaHeartStart.jpeg"
},
{
    "_id": {
        "$oid": "670d71b9c23df6e7b81fd440"
    },
    "nombre": "Pieza interior de maneral para lámpara",
    "descripcion": "Parte interior de plástico para maneral/antorcha compatible con lampara quirúrgica Mindray Hyled 600",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1728935534192-maneral-interior.png"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d86"
    },
    "descripcion": "Teclado de membrana compatible con monitor de signos vitales Drager Infinity Delta",
    "nombre": "Teclado Drager Infinity Delta",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707837345808-TM001.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d88"
    },
    "descripcion": "Teclado de membrana compatible con unidad dental Rojas Dent",
    "nombre": "Teclado Rojas Dent",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707838222768-TM003.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414da0"
    },
    "descripcion": "Teclado de membrana compatible con cama hospitalaria Stryker Muka HC 1100 (lado izquierdo)",
    "nombre": "Teclado Stryker Muka HC 1100 (izquierda)",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707843534726-TM027.jpg"
},
{
    "_id": {
        "$oid": "66969492b889fce0e715a93f"
    },
    "nombre": "Teclado GE MAC 2000",
    "descripcion": "Teclado de membrana compatible con ECG GE Healtcare Mac 2000",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1721143554667-GEMac2000.png"
},
{
    "_id": {
        "$oid": "66e99f0948a7ebcfe937a5f4"
    },
    "nombre": "Teclado Carefusion Vela",
    "descripcion": "Teclado de Membrana compatible con ventilador mecánico Carefusion Vela",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1726586592796-vela.png"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414d87"
    },
    "descripcion": "Teclado de membrana compatible con electrocauterio Valleylab Force FX",
    "nombre": "Teclado Valleylab Force FX",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707837763162-TM002.jpg"
},
{
    "_id": {
        "$oid": "67056010c23df6e7b81fc71f"
    },
    "nombre": "Cuerpo para válvula espiratoria",
    "descripcion": "Cuerpo plástico para válvula espiratoria compatible con ventilador Siare ",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1730131994013-CuerpoValvula.png"
},
{
    "_id": {
        "$oid": "6696a1a8b889fce0e715a9be"
    },
    "nombre": "Esquineros para cuna térmica ",
    "descripcion": "Juego de esquineros para cuna térmica ",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1729527816638-Esquineros.jpeg"
},
{
    "_id": {
        "$oid": "671fb8b7c23df6e7b81ff4e8"
    },
    "nombre": "Abrazadera / Alineador de colchón Hill-Rom",
    "descripcion": "Alineador de colchón compatible con cama hospitalaria Hill Rom",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1730132135084-AlineadorColchon.png"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db2"
    },
    "descripcion": "Membrana compatible con ultrasonido Shimadzu SDU-350XL",
    "nombre": "Membrana Shimadzu SDU-350XL",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707845618685-ME010.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414db4"
    },
    "descripcion": "Membrana compatible con rayos X mobil TMS 300",
    "nombre": "Membrana TMS 300",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707845806362-ME012.jpg"
},
{
    "_id": {
        "$oid": "65ca53ac1e77199bcd414dae"
    },
    "descripcion": "Membrana compatible con cama eléctrica Hill Rom 405 (juego 6 piezas)",
    "nombre": "Membrana Hill Rom 405 (juego 6 piezas)",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1707844945422-ME006.jpg"
},
{
    "_id": {
        "$oid": "663bb9d37d549597b8235f0b"
    },
    "nombre": "Soporte para piernera/bracera Mod1",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 30 mm de altura con 10 mm de espesor.",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715190101123-Soporte-piernera-2.png"
},
{
    "_id": {
        "$oid": "663bbbb57d549597b8235f60"
    },
    "nombre": "Soporte para piernera/bracera Mod2",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 30 mm de altura con 10 mm de espesor.",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715190383828-Soporte-piernera-1.png"
},
{
    "_id": {
        "$oid": "663bbc357d549597b8236027"
    },
    "nombre": "Soporte para piernera/bracera Mod3",
    "descripcion": "Soporte de acero inoxidable para varillas de 1/2\" (12.7 mm) a 3/4\" (19.05 mm) y riel de 31 mm de altura con 11 mm de espesor.",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715190393733-Soporte-piernera-4.png"
},
{
    "_id": {
        "$oid": "663bc0517d549597b823628d"
    },
    "nombre": "Cople para motor Hill Rom",
    "descripcion": "Cople para motor de cama hospitalaria Hill Rom",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715191177444-hillromblanco.png"
},
{
    "_id": {
        "$oid": "663bc1527d549597b82362a7"
    },
    "nombre": "Galleta Hill Rom",
    "descripcion": "Galleta de neopreno para cople de motor Hill Rom ",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715191926986-WhatsApp Image 2024-02-21 at 1.30.54 PM (1).jpeg"
},
{
    "_id": {
        "$oid": "663bc61a7d549597b823644f"
    },
    "nombre": "Pieza de nylamid superior cople Hill Rom",
    "descripcion": "Pieza superior de nylamid para cople de motor Hill Rom",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715198069327-coplesup.jpeg"
},
{
    "_id": {
        "$oid": "663bd9a17d549597b823698b"
    },
    "nombre": "Pieza de nylamid inferior cople Hill Rom",
    "descripcion": "Pieza inferior de nylamid para cople de motor Hill Rom",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1715198101949-copleinf.jpeg"
},
{
    "_id": {
        "$oid": "66886f93b0a2b1bfa7888247"
    },
    "nombre": "Rueda Stryker 8",
    "descripcion": "Rueda de repuesto de 8\" para cama Stryker / ancho rueda 32 mm, longitud del cubo 54 mm, diámetro del eje 11 mm. ",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1720214490447-Stryker.jpeg"
},
{
    "_id": {
        "$oid": "668871e4b0a2b1bfa7888253"
    },
    "nombre": "Rueda Haion 200",
    "descripcion": "Rueda de repuesto de 200 mm para cama Haion / ancho de la rueda 32 mm, longitud del cubo 38 mm, diámetro del eje 8 mm.",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1720214480474-RuedaHaion200.jpeg"
},
{
    "_id": {
        "$oid": "66887408b0a2b1bfa7888265"
    },
    "nombre": "Rueda Caster 6\"",
    "descripcion": "Rueda de repuesto de 6\" / ancho de la rueda de 50.8 mm, longitud del cubo 62.8 mm, diámetro del eje 13 mm",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1720218266936-Caster6.jpeg"
},
{
    "_id": {
        "$oid": "671682c8c23df6e7b81fe052"
    },
    "nombre": "Rueda Haion 125mm / 5\"",
    "descripcion": "Rueda doble con freno externo total de 125mm (5\") sujeción tipo tornillo M12 P=1.75",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1727718730654-HAION_E322_4T125UNBN.png"
},
{
    "_id": {
        "$oid": "67168341c23df6e7b81fe067"
    },
    "nombre": "Rueda Haion 120mm / 4\"",
    "descripcion": "Rueda doble con freno externo total de 100mm (4\") sujeción tipo tornillo M12 P=1.75",
    "categoria": "Productos destacados",
    "imagen": "https://sistema.juvalfri.com/1727722206877-HAION_E322_4T100UNBN.png"
}
]

let shuffled = destacadosData
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

export { shuffled };
